export const MAX_CAPTION_LENGTH = 200
